<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>difondre resultats de votacions</strong>, especialment per mostrar el sentit del vot de mocions, pressupostos, etc. als ajuntaments.
    </p>
    <p>
      Recomanem usar les opcions per canviar l'ordre de les columnes i la posició de l'abstenció per a <strong>donar un missatge clar de quina es la postura que defensa Compromís o denunciar la postura d'un altre grup polític</strong>, intentant destacar-la per damunt de la resta independement del resultat.
    </p>
    <p>
      Podeu afegir i esborrar partits (amb el botonet que apareix a la part superior dreta en passar per damunt), canviar el sentit del vot i la quantitat de vots.
    </p>
    <p>
      Podeu seleccionar i utilitzar els logos dels partits habituals o afegir partits locals seleccionant 'altre'. Recomanem utilitzar les sigles del partit en cas que el nom siga llarg.
    </p>
    <p>
      És pot afegir, si és adient, una foto de fons representativa, un hashtag relacionat amb la temàtica, així com el nom del col·lectiu al costat del logo.
    </p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, canals de Telegram i Whatsapp, etc.).</li>
      <li><strong>9:16</strong>: model per a stories (Instagram, Facebook, Whatsapp). Aquest model no inclou el logo de Comporomís perquè ja és mostra a la part superior esquerra quan es comparteix en l'aplicació. Per favor, no l'afegiu.</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
      <img src="./examples/916.png" alt="Exemple 9:16" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'cards-help'
}
</script>
